import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import { useShowAlert } from "../../../context/AlertContext";
import handleError from "../../../constants/handleError";
import { useAuth } from "../../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import Messages from "../../../constants/Messages";
import {ArrowBackIcon, TrashIcon } from "../../../constants/Icons";

function ConfirmDetele() {
  const [istoken, setVerifyToken] = useState(null);
  const [isOtp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [isBtnLoading, setButtonLoading] = useState(false);

  const { isUser, handleLogout } = useAuth();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const navigate = useNavigate();

  const handleDeleteAccount = async () => {
    if (!checkNetwork()) {
      return;
    } else if (!isOtp) {
      return setError(Messages.AUTH.OTP_REQUIRED);
    } else if (isOtp.length !== 6 || !/^\d{6}$/.test(isOtp)) {
      return setError(Messages.AUTH.OTP_INVALID);
    }

    try {
      setButtonLoading(true);

      const data = { otp: isOtp, verifyToken: istoken };
      const response = await AxiosInstance.post(
        `store-deletion/confirm-deletion`,
        data
      );

      const results = response.data.results || [];

      if (results) {
        handleLogout();
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setButtonLoading(false);
    }
  };

  const fetchDeletionRequest = async () => {
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(
        `store-deletion/request-deletion`
      );

      if (response?.data?.results?.verifyToken) {
        setVerifyToken(response.data.results.verifyToken);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  useEffect(() => {
    fetchDeletionRequest();
  }, []);

  return (
    <div className=" d-flex justify-content-center align-items-center min-vh-100">
      <div
        className="card radius-10 shadow-0 p-4 w-100"
        style={{ maxWidth: "480px" }}
      >
        <div className="text-center mb-3">
          <div className="text-danger mb-2">
            <TrashIcon iClass="font-30 btn-label-danger  rounded-circle w-10 h-10"/>
          </div>
          <h4 className="fw-bold">Delete Your Account</h4>
        </div>
        <div className="alert alert-warning">
          <h6 className="alert-heading mb-1">
            Are you sure you want to delete your account?
          </h6>
          <p className="mb-0">
            Once you delete your account, this action cannot be undone and your
            account will be permanently deteled.
          </p>
        </div>
        <p className="text-center text-muted mb-4">
          A one-time password (OTP) has been sent successfully to email{" "}
          <span className="fw-bold">"{isUser?.email}"</span>. Please enter it
          below to confirm account deletion.
        </p>
        <label className="mb-1">
          {" "}
        Deletion Confirmation  OTP <span className="text-danger">*</span>
        </label>

        <input
          type="text"
          className="form-control mb-2"
          placeholder="Enter OTP"
          value={isOtp}
          maxLength={6}
          onChange={(e) => {
            const value = e.target.value;
            setError("");
            if (/^\d*$/.test(value)) {
              setOtp(value);
            }
          }}
        />

        {error && (
          <div className="error-message invalid-feedback mt-0">{error}</div>
        )}

        <div className="d-flex justify-content-end pt-2">
          {isBtnLoading ? (
            <button className="btn btn-danger pb-0 text-right" disabled>
              <CircularProgress size={22} className="text-white" />
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-danger text-right"
              onClick={handleDeleteAccount}
            >
              <TrashIcon iClass="font-20"/> Delete Account
            </button>
          )}
        </div>

        <div className="d-grid mt-3">
          <div className="btn btn-light" onClick={() => navigate("/dashboard")}>
            <ArrowBackIcon iClass="me-2"/>
            Back To Dashbord
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDetele;
